export default {
  touchPrompt: {
    bottom: "1%",
    left: "50%",
  },

  general: {
    showFavourites: true,
    appResetTimeoutMinutes: 15,
    showSoldNeighbourhoods: false,
    showSoldSlides: false,
  },

  filter: {
    enabled: false,
  },
};
